const portalTypes = ['LOAD_PORTALS', 'SELECT_PORTAL', 'START_PORTAL_PREVIEW', 'STOP_PORTAL_PREVIEW'];

export default portalTypes;
